import { ACTIONS, ActionType } from "actions/recruitmentJourney/types";
import produce, { Draft } from "immer";
import { LoadingState } from "types/api";
import { RecruitmentJourneyState } from "./types";

export const initialState = {
    data: null,
    status: LoadingState.idle,
};

const recruitmentJourney = produce((state: Draft<RecruitmentJourneyState>, action: ActionType) => {
    switch (action.type) {
        case ACTIONS.GET_RECRUITMENT_JOURNEY_REQUEST:
            state.status = LoadingState.loading;
            break;
        case ACTIONS.GET_RECRUITMENT_JOURNEY_SUCCESS:
            state.status = LoadingState.success;
            state.data = action.payload;
            break;
        case ACTIONS.GET_RECRUITMENT_JOURNEY_FAILURE:
            state.status = LoadingState.failure;
            break;
    }
}, initialState);

export default recruitmentJourney;
